<!--  -->
<template>
<div class='container'>
    <div class="item one">
        <div class="text_one">旧密码</div>
        <input type="password" v-model="loginPwd" placeholder="用户登录时的密码">
    </div>
    <div class="item">
        <div class="text_one">新密码</div>
        <input type="password" v-model="newPwd" placeholder="请输入6~10位密码">
    </div>
    <div class="item">
        <div class="text_one">新密码</div>
        <input type="password" v-model="againPwd" placeholder="请重复输入新密码">
    </div>
    <button  class="next" @click="updatePwd">修改</button>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Base64 } from "js-base64"; //base64加密
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    loginPwd:"",//登录时候的密码
    newPwd:"",//新密码
    againPwd:"",//再次输入新密码
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    // 修改密码
    updatePwd(){
        this.$http.companyUpdatePwd({
            pre_password:Base64.encode(this.loginPwd),
            new_password:Base64.encode(this.newPwd),
            new_password_again:Base64.encode(this.againPwd),
        }).then(res=>{
            if(res.status == 1){
                this.$hide.alert({
                    message:res.msg
                })
            }else{
                this.$hide.alert({
                    message:res.msg
                })
            }
        })
    },
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background-color: #f5f5f5;
    .item{
        width: 100%;
        height: 70px;
        background-color: #fff;
        // padding: 10px 18px;
        // box-sizing: border-box;
        border-bottom: 1px solid #DDDDDD;
        .text_one{
            font-size: 14px;
            color: #666666;
            padding: 5px 18px 0;
            box-sizing: border-box;
        }
        input{
            width: 100%;
            border: none;
            // background-color: #fff;
            font-size: 15px;
            color: #999999;
            background-color: transparent;
            // padding-top: -10px;padd
            // padding: 0;
            padding: 0 18px;
            box-sizing: border-box;
        }
    }
    .one{
        margin-top: 20px;
    }
    .next {
    width: 85%;
    height: 44px;
    background-color: #0e88f7;
    border: none;
    color: #ffffff;
    border-radius: 22px;
    margin-top: 60px;
    font-size: 17px;
    display: block;
    text-align: center;
    line-height: 44px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>